<template>
  <div class="row">
    <div class="col-12 mb-3" v-if="message">
      <h6>{{ message }}</h6>
    </div>
    <div class="col-lg-12 col-md-12 text-center" v-loading="loading">
      <el-upload
        v-if="fileList.length === 0"
        action
        :file-list="fileList"
        :on-change="handleUpload"
        :on-exceed="handleExceed"
        :limit="limit"
        :show-file-list="false"
        drag
        :auto-upload="false"
        accept="application/pdf,image/png,image/jpg,image/jpeg"
      >
        <i class="el-icon-upload"></i>
        <div class="el-upload__text">
          Drop file here or <em>click to upload</em>
        </div>
        <div class="el-upload__tip" slot="tip">Only accepting PDF file</div>
      </el-upload>

      <div class="my-3 d-flex flex-column">
        <div
          v-for="(file, index) in fileList"
          :key="file.uid"
          class="row my-1 text-left"
        >
          <div class="col-6 d-flex align-items-center">
            <p class="mb-0">
              <small>{{ file.name }}</small>
            </p>
          </div>
          <div class="col-5">
            <div class="input-group">
              <el-input
                disabled
                readonly
                :value="file.collection_name"
                size="small"
              />
            </div>
          </div>
          <div class="col-1">
            <el-button
              class="py-1 text-navy"
              type="text"
              @click="onDelete(index)"
              icon="el-icon-close"
            >
            </el-button>
          </div>
        </div>
      </div>

      <div
        class="d-flex align-items-center justify-content-between w-100 mt-2"
        v-if="!autoUpload"
      >
        <el-button
          class="btn-secondary"
          v-if="showBefore === true"
          @click="$emit('back')"
        >
          Previous
        </el-button>

        <div class="d-flex align-items-center justify-content-end w-100">
          <el-button class="btn-secondary mr-1" @click="skip"> Skip </el-button>

          <el-button
            class="btn-primary"
            @click="uploadInvoice"
            :disabled="fileList.length == 0"
          >
            Upload invoice
          </el-button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import OCRMixin from "../../../../mixins/OCRMixin";
export default {
  props: {
    showBefore: {
      type: Boolean,
      required: false,
    },
    autoUpload: {
      type: Boolean,
      required: false,
      default: () => {
        return false;
      },
    },
    message: {
      type: String,
      required: false,
      default: () => {
        return "Please upload your purchase invoice to get started";
      },
    },
    invoiceFile: {
      type: Object,
      required: false,
      default: () => {
        return null;
      },
    },
  },
  mixins: [OCRMixin],
  data: () => ({
    fileList: [],
    limit: 1,
    loading: false,
  }),
  mounted() {
    this.fileList = this.invoiceFile != null ? [this.invoiceFile] : [];
  },
  methods: {
    skip(event) {
      this.$emit("continue", undefined);
    },
    handleExceed(files, fileList) {
      this.$message.warning(`You can only upload 1 primary purchase invoice`);
    },
    // this one will request the ocr scanner
    async uploadInvoice() {
      if (this.autoUpload) {
        this.$emit("loading", true);
      }
      try {
        if (this.fileList.length === 0) return;

        this.loading = true;
        const res = await this.ocrScanInvoice(this.fileList[0].raw);
        this.$emit("continue", { ...res.data, file: this.fileList[0] });
      } catch (err) {
        this.$message.error(err.message);
      } finally {
        this.loading = false;
        this.$emit("loading", false);
      }
    },
    handleUpload(file) {
      //   all file uploaded here will be assumed to be an invoice
      file.collection_name = "invoice";

      this.fileList.push(file);
      if (this.autoUpload) {
        this.uploadInvoice();
      }
    },
    onDelete(index) {
      this.fileList.splice(index, 1);
    },
  },
};
</script>
